import { Star, BadgeCheck, Quote } from "lucide-react";
import Reveal, { SectionHeader } from "@/components/Reveal";

const TESTIMONIALS = [
    {
        name: "Dr. Marcelo Cavalcanti",
        role: "Empresário · João Pessoa",
        initials: "MC",
        comment:
            "Atendimento impecável! A barboterapia com toalha quente é sensacional. O ambiente é extremamente refinado e o café de cortesia é nota 10.",
    },
    {
        name: "Gabriel Mendonça",
        role: "Arquiteto · Tambaú",
        initials: "GM",
        comment:
            "Melhor degradê da cidade. Sou cliente fixo há mais de um ano. A pontualidade e o cuidado com os detalhes fazem toda a diferença na Corte Nobre.",
    },
    {
        name: "Rodrigo Alencar",
        role: "Engenheiro · Cabo Branco",
        initials: "RA",
        comment:
            "Lugar fantástico! Estrutura de altíssimo nível em João Pessoa. O Combo Imperador vale cada centavo.",
    },
];

function Stars() {
    return (
        <div className="flex gap-1" aria-label="5 estrelas">
            {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={15} className="fill-gold text-gold" />
            ))}
        </div>
    );
}

export default function Testimonials() {
    return (
        <section
            id="depoimentos"
            data-testid="testimonials-section"
            className="py-20 sm:py-28 lg:py-32 relative overflow-hidden"
        >
            <div
                aria-hidden="true"
                className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[720px] h-[420px] rounded-full bg-gold/5 blur-[130px] pointer-events-none"
            />
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                    <SectionHeader
                        eyebrow="Depoimentos"
                        title="Vozes da Casa"
                        subtitle="O que nossos clientes dizem sobre o ritual Corte Nobre."
                    />
                    <Reveal delay={0.2}>
                        <div className="inline-flex items-center gap-3 glass border border-gold/25 rounded-full px-5 py-3">
                            <span className="font-display text-2xl font-bold text-gold">4.9</span>
                            <div>
                                <Stars />
                                <span className="text-[10px] uppercase tracking-[0.2em] text-cream/55">
                                    Média dos clientes
                                </span>
                            </div>
                        </div>
                    </Reveal>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={t.name} delay={i * 0.12} className="h-full">
                            <figure
                                data-testid="testimonial-card"
                                className="relative h-full rounded-2xl bg-card border border-white/8 hover:border-gold/40 transition-all duration-300 hover:-translate-y-1.5 p-7 flex flex-col"
                            >
                                <Quote size={28} className="text-gold/30 absolute top-6 right-7" />
                                <Stars />
                                <blockquote className="mt-5 text-cream/80 leading-relaxed text-[15px] flex-1">
                                    “{t.comment}”
                                </blockquote>
                                <figcaption className="mt-7 pt-5 border-t border-white/8 flex items-center gap-4">
                                    <span className="flex items-center justify-center w-11 h-11 rounded-full bg-gold/10 border border-gold/35 font-display font-bold text-gold text-sm">
                                        {t.initials}
                                    </span>
                                    <div>
                                        <div className="font-semibold text-cream text-sm flex items-center gap-1.5">
                                            {t.name}
                                            <BadgeCheck size={15} className="text-gold shrink-0" />
                                        </div>
                                        <div className="text-xs text-cream/50 mt-0.5">{t.role}</div>
                                    </div>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1} className="mt-8">
                    <p className="text-center text-xs text-cream/40 font-mono tracking-wider">
                        Depoimentos fictícios para fins de demonstração
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
